module.exports = __webpack_public_path__ + "static/media/success_new.c7b04754.png";